import React from 'react';
import Checkbox from '@mui/material/Checkbox';

export const VpCheckbox = ({ ...rest }) => {
  return <Checkbox {...rest} />;
};



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpCheckbox.jsx